import { useQuery } from '@tanstack/react-query';
import { tagsRecetaAPI, TagRecetaAPI } from '../services/tagsRecetaAPI';

export const tagsRecetaKeys = {
  all: ['tags-receta'] as const,
  list: () => [...tagsRecetaKeys.all, 'list'] as const,
};

/**
 * Hook para listar el catálogo de tags activos. Cacheado 10 minutos: el
 * catálogo cambia poco (administradores agregan tags ocasionalmente).
 */
export const useTagsReceta = () => {
  return useQuery<TagRecetaAPI[]>({
    queryKey: tagsRecetaKeys.list(),
    queryFn: () => tagsRecetaAPI.listar(),
    staleTime: 10 * 60 * 1000,
  });
};

export type { TagRecetaAPI };
